// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NSr8gAEG41P25IlrsXen{--wds-midlight-color: rgba(58, 58, 58, 0.15);background:linear-gradient(to top, var(--wds-midlight-color, rgba(var(--theme-accent-color--rgb), 0.15)) 54%, transparent 54%, transparent 100%);color:var(--theme-page-text-color);font-family:rubik,helvetica,arial,sans-serif;font-size:16px;font-style:normal;font-weight:600;letter-spacing:.16px;line-height:19px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `NSr8gAEG41P25IlrsXen`
};
export default ___CSS_LOADER_EXPORT___;
